var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_vm._t("toolbar"),_c('v-main',[_vm._t("pages")],2),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }